<!--
 * @Description: 左边栏组件，供页面框架使用
 * @Author: laoliu,wanqian
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <div class="body">
    <el-menu class="menu" :unique-opened="true" :router="true"
      :default-active="defaultActiveIndex" >
      <div v-for="func in funcList" :key="func.index">
        <!-- 二级菜单只有一项时不需要展开 -->
        <el-menu-item class="menu-item" v-if="func.submenuList.length == 1" 
          :index="'/' + func.url + '/' + func.submenuList[0].subUrl">
          <i :class="'menu-icon-' + func.url" ></i>
          <span slot="title">{{func.name}}<a :href="'./#/' + func.url + '/' + func.submenuList[0].subUrl" 
              onclick="return false" class="href-normal">{{func.name}}</a></span>
        </el-menu-item>
        <el-submenu class="menu-item" v-else :index="String(func.index)">
          <template slot="title">
            <i :class="'menu-icon-' + func.url"></i>
            <span>{{func.name}}</span>
          </template>
          <el-menu-item class="menu-item" v-for="submenu in func.submenuList" :key="submenu.subUrl+submenu.subIndex" 
            :index="'/' + func.url + '/' + submenu.subUrl">
            {{submenu.name}}<a :href="'./#/' + func.url + '/' + submenu.subUrl" 
              onclick="return false" class="href-normal">{{submenu.name}}</a>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      funcList: []
    };
  },
  computed: {
    defaultActiveIndex: function () {
      //选中下标根据当前菜单来
      return this.$route.path;
    },
  },

  methods: {
  },

  mounted () {
    this.appAxios("GET", this.commonUrl.URL_LIST_FUNCTIONS).then(result => {
      if (result != null) {
        this.funcList = result.data;
      }
    })
  }
}
</script>

<style scoped>
.body {
  width: 100%;
}
.menu {
  margin-left: -10px;
  width: 160px;
  text-align: left;
  border-right: solid 0px #e6e6e6;
}
.menu-icon-overview {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-overview.png");
}
.menu-icon-instmng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-instmng.png");
}
.menu-icon-hspmng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-hspmng.png");
}
.menu-icon-hsvcmng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-hsvcmng.png");
}
.menu-icon-ordermng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-ordermng.png");
}
.menu-icon-usermng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-usermng.png");
}
.menu-icon-reviewmng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-reviewmng.png");
}
.menu-icon-report {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-report.png");
}
.menu-icon-finance {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-finance.png");
}
.menu-icon-hsvccfg {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-hsvccfg.png");
}
.menu-icon-syscfg {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-syscfg.png");
}
.menu-icon-sysmng {
  margin-right: 3px;
  width: 18px;
  height: 18px;
  content: url("../../../assets/pageframe/icon-menu-sysmng.png");
}
.menu-item {
  margin-left: 8px;
  width: 150px;
  text-align: left;
  overflow: hidden;
}
.href-short {
  margin-left: -27px;
  text-decoration: none;
  opacity: 0;
}
.href-normal {
  margin-left: -56px;
  text-decoration: none;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pageframe/components/Aside.vue